export enum TabKey {
  summary = 'summary',
  aiSummary = 'aiSummary',
  analyze = 'analyze',
  properties = 'properties',
  documentPreview = 'document-preview',
  chat = 'chat',
}
